import {Component} from 'react'
import {connect} from 'react-redux'

import mustHaveAcceptedCGU from '../../../../components/Must/MustHaveAcceptedCGU.jsx'
import {isAdmin} from '../../../../../shared/services/userService.js'
import DefaultLayout from '../../../Layout/DefaultLayout.jsx'
import {aiSearchFreelances} from '../../../Search/actions.js'
import FreelanceSearchIACard from '../../../../components/SearchCard/FreelanceIA/FreelanceSearchIACard.jsx'
import FreelanceSearchIAFilterSidebar from './Components/FreelanceSearchIAFilterSidebar.jsx'
import FreelanceSearchIASidePanel from './Components/FreelanceSearchIASidePanel.jsx'
import JsonViewer from '../../../../components/JsonViewer/JsonViewer.jsx'
import Loader from '../../../../../shared/components/Loader/Loader.jsx'
import conf from '../../../../conf.js'
import ArrowRight from 'react-feather/dist/icons/arrow-right.js'
import Aperture from 'react-feather/dist/icons/aperture.js'
// import Cpu from 'react-feather/dist/icons/cpu.js'
import Code from 'react-feather/dist/icons/code.js'
import Tag from 'react-feather/dist/icons/tag.js'
import Zap from 'react-feather/dist/icons/zap.js'
import List from 'react-feather/dist/icons/list.js'
import Search from 'react-feather/dist/icons/search.js'
import CheckCircle from 'react-feather/dist/icons/check-circle.js'
import ChevronDown from 'react-feather/dist/icons/chevron-down.js'
import ChevronRight from 'react-feather/dist/icons/chevron-right.js'

import '../../../Search/SearchIA.scss'

const buildSteps = (prompt) => [
  {
    id: 'besoin',
    icon: Tag,
    title: 'Besoin',
    content: prompt || '…',
  },
  {
    id: 'analyse',
    icon: Zap,
    title: 'Analyse du besoin',
    content: 'La demande est très concise et mentionne uniquement des profils spécialisés JAVA et REACTJS. Le texte ne précise aucun intitulé de poste explicite au-delà de cette recherche de spécialisation, donc le cadre d\'évaluation doit se concentrer exclusivement sur les deux expertises techniques nommées. Je construis donc un framework ciblé sur la présence de preuves concrètes de spécialisation, sans ajouter d\'exigences non mentionnées comme le niveau d\'expérience, la séniorité ou la localisation.',
  },
  {
    id: 'criteres',
    icon: List,
    title: 'Critères de recherche',
    content: 'J\'ai construit un framework à 2 critères centré uniquement sur les éléments explicitement demandés. La spécialisation JAVA (50%) et la spécialisation REACTJS (50%) reçoivent un poids égal, car la formulation met les deux technologies au même niveau d\'importance.',
    items: [
      'Expertise explicite en JAVA, avec preuves issues de l\'expérience professionnelle, des projets réalisés ou des responsabilités techniques mentionnant JAVA.',
      'Expertise explicite en REACTJS, avec preuves issues de l\'expérience professionnelle, des projets réalisés ou des responsabilités techniques mentionnant REACTJS.',
    ],
  },
  {
    id: 'recherche',
    icon: Search,
    title: 'Recherche en cours',
    content: 'Je cible d\'abord des profils fullstack Java / ReactJS ou développeurs front-back ayant une pratique explicite des deux technologies, car ce sont les deux critères décisifs du poste. Comme aucun lieu ni séniorité ne sont imposés, j\'ouvre largement la recherche avec plusieurs formulations proches du besoin pour capter à la fois les profils très précis et ceux dont le positionnement est un peu plus large.',
  },
  {id: 'search1', icon: Search, title: 'Recherche n°1', content: '20 résultats · Score moyen 88% · 16 matchs idéaux', isMeta: true},
  {id: 'search2', icon: Search, title: 'Recherche n°2', content: '20 résultats · Score moyen 81% · 12 matchs idéaux', isMeta: true},
  {id: 'search3', icon: Search, title: 'Recherche n°3', content: '20 résultats · Score moyen 78% · 14 matchs idéaux', isMeta: true},
  {id: 'search4', icon: Search, title: 'Recherche n°4', content: '20 résultats · Score moyen 83% · 14 matchs idéaux', isMeta: true},
  {id: 'search5', icon: Search, title: 'Recherche n°5', content: '20 résultats · Score moyen 73% · 6 matchs idéaux', isMeta: true},
  {
    id: 'compilation',
    icon: CheckCircle,
    title: 'Compilation des meilleurs profils',
    content: 'Twiny a effectué 5 recherches pour vous, analysé 143 profils, et en a trouvé 20 pertinents.',
    isFinal: true,
  },
]

const FINAL_SUBTITLE = 'Twiny a effectué 5 recherches pour vous, analysé 143 profils, et en a trouvé 20 pertinents'

class FreelanceSearchIAContainer extends Component {

  constructor(props) {
    super(props)
    this.state = {
      displayedText: '',
      typingDone: false,
      submitted: false,
      promptValue: '',
      reflexionExpanded: false,
      queryExpanded: false,
      filters: {},
      selectedIndex: null,
    }
    this._typingInterval = null
    this._typingTimeout = null
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleFiltersValidate = this.handleFiltersValidate.bind(this)
    this.handleSelectFreelance = this.handleSelectFreelance.bind(this)
    this.handleCloseSidePanel = this.handleCloseSidePanel.bind(this)
    this.handlePrevFreelance = this.handlePrevFreelance.bind(this)
    this.handleNextFreelance = this.handleNextFreelance.bind(this)
  }

  handleSelectFreelance(index) {
    this.setState({selectedIndex: index})
  }

  handleCloseSidePanel() {
    this.setState({selectedIndex: null})
  }

  handlePrevFreelance() {
    const total = this.props.results.length
    this.setState((prevState) => ({selectedIndex: (prevState.selectedIndex - 1 + total) % total}))
  }

  handleNextFreelance() {
    const total = this.props.results.length
    this.setState((prevState) => ({selectedIndex: (prevState.selectedIndex + 1) % total}))
  }

  buildFiltersPayload() {
    const {filters} = this.state
    const payload = {}
    Object.keys(filters).forEach((key) => {
      if (key === 'city') return
      const value = filters[key]
      if (value === null || value === undefined || value === '') return
      if (Array.isArray(value) && value.length === 0) return
      payload[key] = value
    })
    return payload
  }

  handleFiltersValidate(filters) {
    this.setState({filters, selectedIndex: null}, () => {
      if (this.state.promptValue.trim()) {
        this.setState({submitted: true})
        this.props.aiSearchFreelances(this.state.promptValue, this.buildFiltersPayload())
      }
    })
  }

  handleSubmit(e) {
    e.preventDefault()
    const {promptValue} = this.state
    if (!promptValue.trim()) return
    this.setState({submitted: true, selectedIndex: null})
    this.props.aiSearchFreelances(promptValue, this.buildFiltersPayload())
  }

  handleKeyDown(e) {
    if (e.key === 'Enter' && e.ctrlKey) {
      this.handleSubmit(e)
    }
  }

  componentDidMount() {
    const {currentUser} = this.props
    const fullText = `Bonjour ${currentUser.firstname},`
    this._typingTimeout = setTimeout(() => {
      let i = 0
      this._typingInterval = setInterval(() => {
        i++
        this.setState({displayedText: fullText.slice(0, i)})
        if (i >= fullText.length) {
          clearInterval(this._typingInterval)
          setTimeout(() => this.setState({typingDone: true}), 150)
        }
      }, 55)
    }, 500)
  }

  componentWillUnmount() {
    clearTimeout(this._typingTimeout)
    clearInterval(this._typingInterval)
  }

  render() {
    const {results, loading, currentUser, isAdmin, scores, rawQuery} = this.props
    const {displayedText, typingDone, submitted, promptValue, reflexionExpanded, queryExpanded, selectedIndex} = this.state

    const prefix = 'Bonjour '
    const name = currentUser.firstname
    const prefixPart = displayedText.slice(0, prefix.length)
    const namePart = displayedText.slice(prefix.length, prefix.length + name.length)
    const suffixPart = displayedText.slice(prefix.length + name.length)
    const isTyping = displayedText.length > 0 && !typingDone

    const steps = buildSteps(promptValue)

    const scoreValues = Object.values(scores || {})
    const maxScore = scoreValues.length ? Math.max(...scoreValues) : null

    return (
      <DefaultLayout navbarContained={false} navbarSearch={false}>
        <div className="container-fluid container-search-ia">
          <div className="row row-search-ia">
            <FreelanceSearchIAFilterSidebar
              conf={conf}
              filters={this.state.filters}
              onValidate={this.handleFiltersValidate}
              loading={loading}
            />

            <div className="container dashboard-search-ia">
              <div className="dashboard-search-ia__header">
                <h1>
                  <Aperture size={40} />
                  <span>
                    {prefixPart}
                    {namePart && <em>{namePart}</em>}
                    {suffixPart}
                    {!typingDone && <span className={`typing-cursor${isTyping ? '' : ' typing-cursor--blinking'}`}>|</span>}
                  </span>
                </h1>

                {typingDone && (
                  <form className="dashboard-search-ia__form dashboard-search-ia__form--animated" onSubmit={this.handleSubmit}>
                    <textarea
                      className="form-control"
                      name="ia-prompt"
                      rows="4"
                      placeholder="Décrivez le profil que vous recherchez..."
                      value={promptValue}
                      onChange={(e) => this.setState({promptValue: e.target.value})}
                      onKeyDown={this.handleKeyDown}
                    />
                    <button type="submit" className="btn btn-secondary btn-auto-width" disabled={loading}>
                      <ArrowRight />
                    </button>
                    <div className="dashboard-search-ia__form-hint">
                      <kbd>Ctrl</kbd>
                      <span>+</span>
                      <kbd>Entrée</kbd>
                      <span>Valider</span>
                    </div>
                  </form>
                )}
              </div>

              {/**
              {submitted && !loading && (
                <div className="dashboard-search-ia__reflexion">
                  <div
                    className="reflexion-header"
                    onClick={() => this.setState({reflexionExpanded: !reflexionExpanded})}
                  >
                    <div className="reflexion-header__info">
                      <div className="reflexion-header__icon-wrap">
                        <Cpu size={20} />
                      </div>
                      <div>
                        <div className="reflexion-header__title">Raisonnement</div>
                        <div className="reflexion-header__subtitle">{FINAL_SUBTITLE}</div>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      onClick={(e) => { e.stopPropagation(); this.setState({reflexionExpanded: !reflexionExpanded}) }}
                    >
                      Voir la réflexion de Twiny
                      {reflexionExpanded
                        ? <ChevronDown size={18} className="ml-2" />
                        : <ChevronRight size={18} className="ml-2" />
                      }
                    </button>
                  </div>

                  {reflexionExpanded && (
                    <div className="reflexion-timeline">
                      {steps.map((step, index) => {
                        const Icon = step.icon
                        const showLine = index < steps.length - 1

                        return (
                          <div
                            key={step.id}
                            className={[
                              'reflexion-timeline__step',
                              step.isMeta ? 'reflexion-timeline__step--meta' : '',
                              step.isFinal ? 'reflexion-timeline__step--final' : '',
                            ].filter(Boolean).join(' ')}
                          >
                            <div className="reflexion-timeline__connector">
                              <span className="reflexion-timeline__bullet" />
                              {showLine && <span className="reflexion-timeline__line" />}
                            </div>

                            <div className="reflexion-timeline__content">
                              <div className="reflexion-timeline__header">
                                <div className="reflexion-timeline__title-row">
                                  <Icon size={18} className="reflexion-timeline__icon" />
                                  <span className="reflexion-timeline__title">{step.title}</span>
                                </div>
                                {step.isMeta && (
                                  <span className="reflexion-timeline__meta">{step.content}</span>
                                )}
                              </div>

                              {!step.isMeta && (
                                <div className="reflexion-timeline__body">
                                  <p>{step.content}</p>
                                  {step.items && (
                                    <ol>
                                      {step.items.map((item, i) => <li key={i}>{item}</li>)}
                                    </ol>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  )}
                </div>
              )}
              */}

              {submitted && !loading && (
                <div className="dashboard-search-ia__reflexion">
                  <div
                    className="reflexion-header"
                    onClick={() => this.setState({queryExpanded: !queryExpanded})}
                  >
                    <div className="reflexion-header__info">
                      <div className="reflexion-header__icon-wrap">
                        <Code size={20} />
                      </div>
                      <div>
                        <div className="reflexion-header__title">Requête</div>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      onClick={(e) => { e.stopPropagation(); this.setState({queryExpanded: !queryExpanded}) }}
                    >
                      Voir la requête ES
                      {queryExpanded
                        ? <ChevronDown size={18} className="ml-2" />
                        : <ChevronRight size={18} className="ml-2" />
                      }
                    </button>
                  </div>

                  {queryExpanded && (
                    <div className="reflexion-timeline">
                      <JsonViewer data={rawQuery} />
                    </div>
                  )}
                </div>
              )}

              {submitted && loading && (
                <div className="dashboard-search-ia__loading text-center">
                  <Loader fill={false} visible />
                  <p className="mt-2">Analyse de votre besoin...</p>
                </div>
              )}

              {submitted && !loading && (
                results.length === 0 ? (
                  <div className="dashboard-search-ia__empty">
                    <p className="mt-2">Aucun consultant trouvé.</p>
                  </div>
                ) : (
                  <>
                    <p className="dashboard-search-ia__number">
                      <strong>{results.length} {results.length > 1 ? 'profils' : 'profil'}</strong>&nbsp;{results.length > 1 ? 'pertinents trouvés' : 'pertinent trouvé'}
                    </p>
                    <div className="dashboard-search-ia__results">
                      {results.map((freelance, index) => (
                        <FreelanceSearchIACard
                          key={freelance.id}
                          freelance={freelance}
                          currentUser={currentUser}
                          isAdmin={isAdmin}
                          matchPercentage={maxScore ? Math.round((scores?.[freelance.id] / maxScore) * 100) : null}
                          score={scores?.[freelance.id]}
                          selected={selectedIndex === index}
                          onOpen={() => this.handleSelectFreelance(index)}
                        />
                      ))}
                    </div>
                  </>
                )
              )}
            </div>

            {selectedIndex !== null && results[selectedIndex] && (
              <FreelanceSearchIASidePanel
                freelance={results[selectedIndex]}
                currentUser={currentUser}
                isAdmin={isAdmin}
                matchPercentage={maxScore ? Math.round((scores?.[results[selectedIndex].id] / maxScore) * 100) : null}
                index={selectedIndex}
                total={results.length}
                onPrev={this.handlePrevFreelance}
                onNext={this.handleNextFreelance}
                onClose={this.handleCloseSidePanel}
              />
            )}
          </div>
        </div>
      </DefaultLayout>
    )
  }
}

export default mustHaveAcceptedCGU(
  connect(
    (state) => ({
      isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse),
      currentUser: state.currentUser.user,
      results: state.search.results,
      scores: state.search.scores,
      rawQuery: state.search.rawQuery,
      loading: state.search.loading,
    }),
    (dispatch) => ({
      aiSearchFreelances: (query, filters) => dispatch(aiSearchFreelances(query, filters))
    })
  )(FreelanceSearchIAContainer)
)
